import { Autocomplete, Grid, TextField } from '@mui/material'
import React from 'react'

const Rhythm = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={8}>
    <Autocomplete
      options={[
        'Normal Sinus Rhythm',
        'Sinus Tachycardia',
        'Sinus Bradycardia',
        'Sinus Arrhythmia',
        'Atrial Fibrillation',
        'Atrial Flutter',
        'Ventricular Tachycardia',
        'Atrioventricular Nodal Reentrant Tachycardia (AVNRT)',
        'Atrioventricular Reentrant Tachycardia (AVRT)',
        'Wolff-Parkinson-White (WPW) Syndrome',
        'First Degree AV Block',
        'Second Degree AV Block Type I (Wenkebach)',
        'Second Degree AV Block Type II',
        'Third Degree AV Block',
        'Premature Ventricular Contraction (PVC)',
        'Premature Atrial Contraction (PAC)',
      ]}
      value={moduleValues?.['Rhythm'] ?? []}
      onChange={(e, value) =>
        setModuleValues((prev) => ({ ...prev, ['Rhythm']: value }))
      }
      renderInput={(params) => <TextField {...params} label="Rhythm" />}
      multiple
    />
  </Grid>
)

export default Rhythm